/**
 * Target picker chips for roundtable follow-ups (§7h).
 *
 * Sits above the message input on an existing roundtable. Lets the
 * user direct the next message to a specific panellist ("Ask Bezos")
 * or to the whole panel ("Ask panel"). Default is the panel.
 *
 * PRD §4.3.3 resolved this as `targetPersonaId` on the follow-up
 * request body — null/undefined means all panellists respond in
 * order, a specific id means only that panellist responds. Backend
 * validation in parseRoundtableFollowupBody + handleRoundtableFollowup
 * (7d) rejects ids that aren't members of the stored panel, so the
 * UI only needs to surface valid choices.
 *
 * Chips vs dropdown was the §7h scoping Q1 — chips are more visually
 * clear, mobile-friendly, one-click to target, and match the
 * enterprise SaaS aesthetic.
 */

export default function TargetPicker({
  personaIds,
  personas,
  targetPersonaId,
  onChange,
  disabled = false,
}) {
  const personaMap = new Map(
    (personas || []).filter((p) => personaIds.includes(p.id)).map((p) => [p.id, p]),
  );

  return (
    <div className="target-picker" role="radiogroup" aria-label="Who should respond">
      <button
        type="button"
        className={`target-chip ${!targetPersonaId ? "target-chip-active" : ""}`}
        onClick={() => onChange(null)}
        disabled={disabled}
        role="radio"
        aria-checked={!targetPersonaId}
      >
        Ask panel
      </button>
      {personaIds.map((id, i) => {
        const p = personaMap.get(id);
        const active = targetPersonaId === id;
        return (
          <button
            key={id}
            type="button"
            className={`target-chip target-chip-${i + 1} ${
              active ? "target-chip-active" : ""
            }`}
            onClick={() => onChange(id)}
            disabled={disabled}
            role="radio"
            aria-checked={active}
          >
            Ask {p?.name || id}
          </button>
        );
      })}
    </div>
  );
}
